import { useTranslation } from 'react-i18next'

import { Link } from 'features/i18n/router'
import { serializeGroupData } from 'lib/group'
import { ROUTE_PATH } from 'lib/paths'
import { useGetGroupsQuery } from 'store/api/yay/group'

import GroupList from 'components/GroupList'
import GroupItemSkeletonLoading from '../GroupList/GroupItemSkeletonLoading'

const ActiveGroupsSection = () => {
  const { t } = useTranslation()

  const groupsRes = useGetGroupsQuery({})

  return (
    <div className="Sidebar__content">
      <div className="Sidebar__content__header">
        <h3 className="Sidebar__content__header__title">
          {t('common.recently_updated_group')}
        </h3>
      </div>

      {!groupsRes.isSuccess ? (
        <>
          <GroupItemSkeletonLoading />
          <GroupItemSkeletonLoading />
          <GroupItemSkeletonLoading />
        </>
      ) : (
        <GroupList
          groups={{
            ...groupsRes,
            data: serializeGroupData(groupsRes?.data),
          }}
          showViewCount={false}
          showMenu={false}
          smallDetailedSettings
          descriptionMaxLine={2}
        />
      )}

      <div className="Sidebar__content__footer">
        <Link
          to={ROUTE_PATH.GROUPS_ALL}
          className="Sidebar__content__footer__link"
        >
          {t('common.see_all_group')}
        </Link>
      </div>
    </div>
  )
}

export default ActiveGroupsSection
